"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var HoCs_1 = require("utils/HoCs");
var single_1 = require("utils/selectors/single");
var FreePlanCheckout_1 = __importDefault(require("./FreePlanCheckout"));
var TrialCheckout_1 = __importDefault(require("./TrialCheckout"));
var Checkout = function (_a) {
    var company = _a.company;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var isWelcomeFlow = (0, react_router_1.useRouteMatch)('/welcome');
    var isOAuthLanding = (0, react_router_1.useRouteMatch)('/oauth');
    var isHomeURL = (0, react_router_1.useRouteMatch)({ path: '/', exact: true });
    var showCheckoutBanner = (0, end2end_1.userCan)(interfaces_1.ACCESS_LEVEL.Admin)(profile)
        && ((company === null || company === void 0 ? void 0 : company.plan) === 'Start-Up' || (company === null || company === void 0 ? void 0 : company.planStatus) !== 'active');
    if (end2end_1.IS_RECHARGLY || (profile === null || profile === void 0 ? void 0 : profile.closedCheckoutBanner) || isWelcomeFlow || isHomeURL || !showCheckoutBanner || isOAuthLanding) {
        return null;
    }
    if ((company === null || company === void 0 ? void 0 : company.planStatus) === 'in_trial' && (company === null || company === void 0 ? void 0 : company.plan) === 'Growth') {
        return (0, jsx_runtime_1.jsx)(TrialCheckout_1.default, { company: company, profile: profile });
    }
    return (0, jsx_runtime_1.jsx)(FreePlanCheckout_1.default, { profile: profile, hasTakenTrial: !company.freeTrialFinishDate });
};
exports.default = (0, HoCs_1.HasCompanyHoC)(Checkout, true);
